import React, { useEffect, useState } from 'react';
import { authService } from './auth-service';

const Login = ({ onLoginSuccess }) => {
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated (after OAuth redirect)
    const checkAuthStatus = async () => {
      try {
        const currentUser = await authService.getCurrentUser();
        if (currentUser) {
          // User is authenticated, notify parent
          onLoginSuccess(currentUser);
          return;
        }
      } catch (err) {
        console.error('Auth check error:', err);
      } finally {
        setChecking(false);
      }

      // Check for OAuth error in URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const oauthError = urlParams.get('error');

      if (oauthError) {
        setError(decodeURIComponent(oauthError));
        // Clean URL
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    };

    checkAuthStatus();
  }, [onLoginSuccess]);

  const handleLogin = () => {
    // Redirect to Authentik via backend
    authService.login();
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 to-primary/15">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification de l'authentification...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 to-primary/15 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-2xl">
        <div className="text-center">
          {/* Logo placeholder - add your logo here */}
          <div className="mx-auto h-16 w-16 bg-primary rounded-full flex items-center justify-center mb-4">
            <svg className="h-10 w-10 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
            </svg>
          </div>

          <h2 className="text-3xl font-extrabold text-gray-900 mb-2">
            SuiviPlus
          </h2>
          <p className="text-sm text-gray-600 mb-8">
            Gestion de stocks pour micro-crèches
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">
                  {error || 'Erreur de connexion'}
                </p>
              </div>
            </div>
          </div>
        )}

        <div className="space-y-4">
          <button
            onClick={handleLogin}
            className="group relative w-full flex justify-center items-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            <svg className="w-5 h-5 mr-2" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
            </svg>
            Se connecter avec Delogic SSO
          </button>

          <div className="text-center">
            <p className="text-xs text-gray-500">
              Connexion sécurisée via Authentik
            </p>
          </div>
        </div>

        <div className="mt-8 border-t pt-6">
          <div className="text-center text-xs text-gray-400">
            <p>SuiviPlus v2.0 - Sécurisé avec OAuth2</p>
            <p className="mt-1">© 2025 Delogic Consulting</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
